<div class="branding-header">
  <div class="cafler-row">
    <img src="../assets/icons/cafler-logo.svg" alt="Cafler icon" class="cafler-icon" />
    <span class="powered-text-cafler">Cafler</span>
  </div>
  <div *ngIf="logoUrl !== ''" class="powered-row">
    <span class="powered-text">Powered by</span>
    <img [src]="logoUrl" />
  </div>
  <select [(ngModel)]="selectedLang" class="language-select" (change)="changeLanguage($event)">
    <option value="es">ES</option>
    <option value="en">GB</option>
  </select>
</div>
